import { useState } from 'react';
import { getPaymentMethods } from '../../../services/general';
import codes from '../../../utils/providerCodes.json';

const usePaymentMetods = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [defaultData, setDefaultData] = useState();

  const getPaymentData = async (reservation) => {
    try {
      const response = await getPaymentMethods({
        company_id: reservation.company_id
      });
      const invalidCodes = [codes.convenio, codes.convenioOC];
      let filteredOptions;
      if (response?.some((option) => option.default_method)) {
        filteredOptions = response.filter((option) => option.default_method
          || reservation.payment_methods_codes.includes(option.code)
        );
      } else {
        filteredOptions = response?.filter((option) => codes.sucursal !== option.code
          && (
            !invalidCodes.includes(option.code)
            || reservation.payment_methods_codes.includes(option.code)
          )
          && (
            option.code !== codes.toku
            || reservation.payment_methods_codes.includes(option.code)
          )
        );
      }
      setData(filteredOptions);
      setDefaultData(response?.find((option) => option.default_method));
      return response;
    } catch (error) {
      console.error(error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }

  return { data, defaultData, error, isLoading, getPaymentData };
};

export default usePaymentMetods;